function Footer() {
  return (
    <footer>
      <p>Charmie’s Kastle</p>
      <span>Thank you for visiting the Kastle.</span>
    </footer>
  );
}

export default Footer;